import { useState, type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { http, setToken } from '@/api/client';
import { useMe } from '@/api/hooks';
import { useUi } from '@/app/store';
import { Sheet } from '@/components/Sheet';
import { Skeleton } from '@/components/ui';
import { platform } from '@/platform';
import { DailyRewardSheet } from '../home/DailyRewardSheet';
import { usePaywall } from '../paywall/Paywall';
import { Icon, type IconName } from '@/components/Icon';

export function ProfileScreen() {
  const nav = useNavigate();
  const { data: me } = useMe();
  const reduced = useUi((s) => s.reducedMotion);
  const setReduced = useUi((s) => s.setReducedMotion);
  const { paywall, openPaywall } = usePaywall();
  const [reward, setReward] = useState(false);
  const [confirm, setConfirm] = useState(false);

  if (!me) return <div className="screen"><Skeleton h={200} /></div>;
  const until = me.premiumUntil ? new Date(me.premiumUntil).toLocaleDateString('ru-RU') : null;

  const deleteAccount = async () => {
    await http.post('/account/delete');
    setToken(null);
    localStorage.clear();
    platform.close();
    location.reload();
  };

  return (
    <div className="screen">
      <div className="topbar"><div className="title">Профиль</div></div>
      <div className="stack">
        <div className="card lg row">
          <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'var(--primary)', display: 'grid', placeItems: 'center', fontSize: 24, overflow: 'hidden' }}>
            {me.avatarUrl ? <img src={me.avatarUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : me.displayName[0]}
          </div>
          <div style={{ flex: 1 }}>
            <h2>{me.displayName}</h2>
            <div className="dim">{me.premium ? `✨ Premium до ${until}` : 'Бесплатный тариф'}</div>
            <div className="streak"><Icon name="flame" size={14} filled />Стрик {me.streak.current} · рекорд {me.streak.best}</div>
          </div>
        </div>
        <div className="grid3">
          <Stat ic="crystal" cls="c-crystal" v={me.wallet.crystals} t="кристаллы" /><Stat ic="shard" cls="c-shard" v={me.wallet.shards} t="осколки" /><Stat ic="ticket" cls="c-gold" v={me.wallet.tickets} t="билеты" />
        </div>
        {me.dailyReward.available && <button className="btn warm" onClick={() => setReward(true)}><Icon name="gift" size={18} />Забрать ежедневную награду</button>}
        {!me.premium && <button className="btn primary" onClick={() => void openPaywall('premium')}><Icon name="sparkle" size={16} filled />Оформить Premium</button>}
        <div className="menu-group">
        <Menu ic="history" t="История раскладов" onClick={() => nav('/history')} />
        <Menu ic="cards" t="Колоды" onClick={() => nav('/decks')} />
        <Menu ic="users" t="Пригласить друга" onClick={() => platform.share('Попробуй Таро — карта дня и расклады с ИИ', `${location.origin}?startapp=ref_${me.id}`)} />
        <Menu ic="motion" t={reduced ? 'Включить анимации' : 'Меньше анимаций'} onClick={() => setReduced(!reduced)} />
        {platform.name === 'web' && (
          <Menu ic="info" t={`Dev: сменить пользователя (id ${localStorage.getItem('devId') ?? 1})`} onClick={() => {
            const id = prompt('devId', localStorage.getItem('devId') ?? '1');
            if (id) { localStorage.setItem('devId', id); setToken(null); location.reload(); }
          }} />
        )}
        </div>
        <div className="hr" />
        <p className="dim center">Приложение носит развлекательный характер и не заменяет консультацию специалиста.</p>
        <button className="btn ghost danger" onClick={() => setConfirm(true)}>Удалить аккаунт</button>
      </div>

      <DailyRewardSheet open={reward} onClose={() => setReward(false)} />
      <Sheet open={confirm} onClose={() => setConfirm(false)}>
        <div className="stack center">
          <h2>Удалить аккаунт?</h2>
          <p className="muted">Все расклады, предметы и покупки будут удалены без возможности восстановления.</p>
          <button className="btn ghost danger" onClick={deleteAccount}>Да, удалить</button>
          <button className="btn primary" onClick={() => setConfirm(false)}>Отмена</button>
        </div>
      </Sheet>
      {paywall}
    </div>
  );
}

const Stat = ({ ic, cls, v, t }: { ic: IconName; cls: string; v: number; t: string }) => <div className="card center stat"><Icon name={ic} size={22} className={cls} /><b>{v}</b><div className="dim">{t}</div></div>;
const Menu = ({ ic, t, onClick }: { ic: IconName; t: ReactNode; onClick: () => void }) => (
  <button className="menu-item" onClick={onClick}><Icon name={ic} size={20} className="menu-ic" /><span style={{ flex: 1 }}>{t}</span><Icon name="chevron" size={18} className="dim" /></button>
);
